<template>
    <register-layout v-on:submit="submit">
        <div class="tw-grid tw-grid-cols-1 tw-gap-6 tw-p-6">

            <div class="tw-text-xl tw-font-bold">{{$text.i_will_now_create_your_matchmarry_account}}</div>

            <div>
                <label class="tw-flex tw-items-center tw-space-x-2">
                    <input type="checkbox" v-model="states.form.rules" class="tw-inline-block tw-w-4 tw-h-4 tw-flex-shrink-0"/>
                    <div>
                        I certify that I am over 18 and accept the
                        <a class="rules-link" target="_blank" href="/terms-and-conditions">Terms & Conditions</a>.
                        Learn about how we process your data in our
                        <a class="rules-link" target="_blank" href="/privacy-policy">Privacy Policy</a>,
                        <a class="rules-link" target="_blank" href="/cookie-policy">Cookie Policy</a> and our
                        <a class="rules-link" target="_blank" href="/rules-on-profiles-visibility">Rules on Profiles Visibility</a>.
                    </div>
                </label>
                <div v-html="_.get(errors,'rules.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>
            <div>
                <label class="tw-flex tw-items-center tw-space-x-2">
                    <input type="checkbox" v-model="states.form.dataRules" class="tw-inline-block tw-w-4 tw-h-4 tw-flex-shrink-0"/>
                    <div>
                        I consent to the processing of my
                        <a class="rules-link" target="_blank" href="/sensitive-data">sensitive data</a>.
                        by Match to provide me the service.
                    </div>
                </label>
                <div v-html="_.get(errors,'dataRules.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>
            <div>
                <label class="tw-flex tw-items-center tw-space-x-2">
                    <input type="checkbox" v-model="states.form.emailRules" class="tw-inline-block tw-w-4 tw-h-4 tw-flex-shrink-0"/>
                    <div>
                        I would like to receive via email commercial offers relating to
                        products or services provided by partners of MatchMarry.com
                        International Limited. See our
                        <a class="rules-link" target="_blank" href="/partnerships">partners</a>.
                        You may opt-out at any time in your settings.
                    </div>
                </label>
                <div v-html="_.get(errors,'emailRules.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>

        </div>
    </register-layout>
</template>
<script>
    import store from './register-store'
    import RegisterLayout from './register-layout'

    export default {
        components: {RegisterLayout},
        data: v => ({
            states: store.states,
            errors: {},
        }),
        created() {
            this.store = store
        },
        methods: {
            submit() {
                store.states.loading = true
                axios.post('/validate-register', store.composeForm())
                    .then(() => {
                        this.errors = {}
                    })
                    .catch(err => {
                        err.response.status === 422 && (this.errors = err.response.data.errors)
                    })
                    .finally(() => {
                        store.states.loading = false
                        if (store.hasNoErrors(this.errors, ['rules', 'dataRules', 'emailRules'])) {
                            store.submit()
                        }
                    })
            },
        },
    }
</script>
